import 'react';
import { Alert, Text } from 'reaxl';
import { jsxs, jsx } from 'react/jsx-runtime';
const getUpdates = _ref => {
  let {
    vehicle,
    deal,
    creditApp,
    isEcommerce
  } = _ref;
  const {
    dealTypeChangeFlag,
    paymentChangeFlag
  } = deal;
  const {
    priceChangeFlag,
    sellingVehicleChangeFlag
  } = vehicle;
  const {
    isDecisionChanged
  } = creditApp;
  const updatedFields = [sellingVehicleChangeFlag, dealTypeChangeFlag, paymentChangeFlag, priceChangeFlag, isDecisionChanged, isEcommerce].filter(flag => flag === true);
  const hasBeenUpdated = updatedFields.length > 0;
  const updates = [];
  if (isEcommerce) {
    updates.push('esntial');
  }
  if (sellingVehicleChangeFlag) {
    updates.push('vehicle');
  }
  if (priceChangeFlag) {
    updates.push('price');
  }
  if (paymentChangeFlag) {
    updates.push('monthly payment');
  }
  if (dealTypeChangeFlag) {
    updates.push('finance option');
  }
  if (isDecisionChanged) {
    updates.push('credit app');
  }
  return {
    hasBeenUpdated,
    updates
  };
};
const getMessage = (updates, vehicle) => {
  const formatter = new Intl.ListFormat('en', {
    type: 'conjunction'
  });
  const formattedChanges = formatter.format(updates);
  if (updates.includes('esntial')) {
    return `Congratulations! You're the new driver of a ${vehicle.year} ${vehicle.make.name || vehicle.make} ${vehicle.model.name || vehicle.model}`;
  }
  if (updates.includes('credit app') && updates.length === 1) {
    return 'The deal terms and monthly payment may have changed based on the credit decision.';
  }
  return `The ${formattedChanges} ${updates.length > 1 ? 'have' : 'has'} changed.`;
};
function DealCardAlert(_ref2) {
  let {
    vehicle,
    deal,
    creditApp,
    isEcommerce = false
  } = _ref2;
  const {
    hasBeenUpdated,
    updates
  } = getUpdates({
    vehicle,
    deal,
    creditApp,
    isEcommerce
  });
  const message = getMessage(updates, vehicle);
  if (!hasBeenUpdated) {
    return null;
  }
  const alertTitle = updates.includes('esntial') ? 'Your order is confirmed!' : 'Details about this deal have changed.';
  return /*#__PURE__*/jsxs(Alert, {
    bsStyle: "info",
    children: [/*#__PURE__*/jsx(Text, {
      className: "text-bold",
      children: alertTitle
    }), message && /*#__PURE__*/jsx("div", {
      children: message
    })]
  });
}
export { DealCardAlert as default };
